import {ReactComponent as ListIcon} from "../../assets/images/icons/list.svg";
import {ReactComponent as SettingIcon} from "../../assets/images/icons/setting.svg";
import {ReactComponent as GridIcon} from "../../assets/images/icons/grid.svg";
import {useParams} from "react-router-dom";
import ProductController from "../../../Products/controller/ProductController";
import React, {useState} from "react";
import StateModalModel from "../../../../components/Modal/Model/StateModalModel";
import ModalComponents from "../../../../components/Modal/Modal";
import CheckPassModal from "./CheckPassModal/CheckPassModal";
import AppSettingController from "../../../Main/controller/AppSettingController";
import marketSettingLocalStorage from "../../../Main/interface/MarketSettingLocalStorage";
import {get} from "lodash";
import pwaStatus from "../../../../utility/pwaStatus";
import {useTranslation} from "react-i18next";


export default function HomeHeader() {
    const {t} = useTranslation();
    const {isMobile} = pwaStatus()
    const [stateModal, setStateModal] = useState<StateModalModel>({
        body: <CheckPassModal/>,
        closeLabel: "",
        show: false,
        submit(): void {
        },
        submitLabel: "",
        title: "",
        modalClassName: "password-modal-component",
    })

    const {shopId} = useParams();
    const setting = AppSettingController.getSetting() as marketSettingLocalStorage
    const canShowSetting = !isMobile && get(setting, "setting", true)

    return (
        <section className={"home-header"}>
            <div className={"header-container"}>
                <div className={"store-name"}>
                    <h1>{get(setting, "name", t("shop"))}</h1>
                </div>
                {shopId ? <div className="setting">
                    <div onClick={() => ProductController.productArrangementToggle()}>
                        {setting.isList ? <GridIcon/> : <ListIcon/>}
                    </div>
                    {canShowSetting ? <SettingIcon onClick={() => setStateModal({...stateModal, show: true})}/> : null}
                </div> : null}
            </div>
            <ModalComponents state={stateModal} setState={setStateModal}/>
        </section>

    )
}